/* 平台创建的排班-时刻表 */
<template>
  <div id="schedulingTimeForm">

    <div class="schedulingTimeForm-head">
      <div class="schedulingTimeForm-head-left">
        <img class="icon-line" src="../../../assets/img/line.png" alt=""/>
        <span style="font-weight: 600" v-if="schedulingJson">{{ getWeek(selectSchedulingTime) }} {{
            selectSchedulingTime |
                filterTime("MM-DD")
          }}</span>
        <span style="margin:0 10px">|</span>
        <span style="font-weight: 600">{{ lineInfo.startStationName }} - {{ lineInfo.endStationName }}</span>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="editShift">编辑班次</el-button>
      </div>
    </div>

    <!-- 班次列表 -->
    <div class="schedulingTimeForm-body">
      <div class="scheduling-form-date">
        <div class="left">
          <custom-across-roll ref="customAcrossRoll">
            <div v-for="(scheduling, i) in schedulingJson" :key="i" class="date"
                 :class="dateActiveIndex == i ? 'active' : ''" @click="dateClick(scheduling, i)"
                 @mouseover="dateHover('over', i)" @mouseout="dateHover('out', i)">
              <span class="date-text">
                {{ getWeek(scheduling.schedulingTime) }}
                {{ scheduling.schedulingTime | filterTime("MM-DD") }}
              </span>
              <span class="date-close" :class="scheduling.removeIconShow == 1 ? 'remove' : ''"
                    @click.stop="removeSchedulingTime(scheduling, i)">×</span>
            </div>


          </custom-across-roll>
        </div>
      </div>

      <div class="util-remark">
        注意：如需修改已保存班的时间、车辆、开启/关闭售票，请在【班线调度】中操作
        <el-button type="text" style="font-size: 14px;" @click="dispatchLineClick">点击前往</el-button>
      </div>

      <div class="scheduling-form-table">
        <el-table :data="form.shiftActive" border style="width: 100%">
          <el-table-column prop="startTime" label="班次时间"></el-table-column>
          <!--          <el-table-column prop="endTime" label="发车时间"></el-table-column>-->
          <el-table-column prop="licenseNo" label="车辆号牌" v-slot="{ row }">
            {{
              row.schedulingVehicleJson && row.schedulingVehicleJson[0] ? row.schedulingVehicleJson[0].licenseNo : '-'
            }}
          </el-table-column>
          <el-table-column prop="vehicleNo" label="车辆编号" v-slot="{ row }">
            {{
              row.schedulingVehicleJson && row.schedulingVehicleJson[0] ? row.schedulingVehicleJson[0].vehicleNo : '-'
            }}
          </el-table-column>
          <el-table-column prop="vehicleModel" label="车型" v-slot="{ row }">
            {{
              row.schedulingVehicleJson && row.schedulingVehicleJson[0] ? row.schedulingVehicleJson[0].vehicleModel : ''
            }}
          </el-table-column>
          <el-table-column prop="vehicleSeat" label="座位数" v-slot="{ row }">
            {{
              row.schedulingVehicleJson && row.schedulingVehicleJson[0] ? row.schedulingVehicleJson[0].vehicleSeat : '-'
            }}
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schedulingTimeForm",
  components: {
    customAcrossRoll: () => import("../../../components/custom-across-roll.vue"),
  },
  data() {
    return {
      lineId: this.$route.query.id,
      // 表单对象
      form: {
        // 当前选中的
        shiftActive: [],
      },
      // 线路详情信息
      lineInfo: {},
      //线路详情数据
      priceForm: {
        stationRailFee: [],
      },

      // 加载中
      loading: false,

      schedulingJson: [],
      // 选中的日期索引
      dateActiveIndex: 0,
      //点击查看座位数据
      seats: [],

      editShiftDialogVisible: false,
      editShiftForm: {},

      // 当前选择的排班日期
      selectSchedulingTime: null,
    };
  },
  watch: {
    "form.shiftActive"() {
      this.selectSchedulingTime = this.schedulingJson[this.dateActiveIndex].schedulingTime;
    },
  },

  created() {
    this.getInfo();
  },
  methods: {
    /* 日期鼠标悬浮 */
    async dateHover(type, i) {
      let obj = new Object(this.schedulingJson[i]);
      if (type == "over" && obj.removeIconShow) {
        this.schedulingJson[i].removeIconShow = 1;
      }
      if (type == "out" && obj.removeIconShow) {
        this.schedulingJson[i].removeIconShow = 2;
      }
    },
    validateStart(rule, value, callback) {
      let item = this.editShiftForm.startTime;
      let beforeTime = this.editShiftForm.beforeTime;
      let afterTime = this.editShiftForm.afterTime;
      if (!value) {
        callback(new Error("“接人/检票时间”不能为空"));
      } else if (beforeTime && item < beforeTime) {
        callback(new Error("请设置大于等于上个班次的“接人/检票时间”"));
      } else if (afterTime && item > afterTime) {
        callback(new Error("请设置小于等于下个班次的“接人/检票时间”"));
      } else {
        callback();
      }
    },
    /* 验证器-编辑发车时间 */
    validateEnd(rule, value, callback) {
      let item = this.editShiftForm.endTime;
      let startItem = this.editShiftForm.startTime;
      if (!value) {
        callback(new Error("发车时间不能为空"));
      } else if (item < startItem) {
        callback(new Error("不能小于“接人/检票时间”"));
      } else {
        callback();
      }
    },


    /* 获取平台排班信息 dateActiveIndex 指定日期下标 */
    async getInfo() {
      let url = "/api/v1/manage/line/scheduling/" + this.lineId;
      let res = await this.$axios.get(url, {channel: 1});
      if (res?.code == 1) {
        res = res.data;
        this.schedulingJson = [];
        let currentList = [];
        if (res.scheduling?.length > 0) {
          let minTime = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点
          let lastTime = res.scheduling[res.scheduling.length - 1].schedulingTime;
          if (lastTime - minTime && (lastTime - minTime) / 86400 + 1 != res.scheduling.length) {
            // 日期组缺少日期手动补偿，正常不会存在此情况
            for (let i = 0; i < (lastTime - minTime) / 86400 + 1; i++) {

              let item = res.scheduling.find((item) => item.schedulingTime == minTime + 86400 * i);
              if (item) {
                let soldTicketsSum = 0;
                if (item.shift && item.shift.length > 0) {
                  soldTicketsSum = item.shift.reduce(function (prev, cur) {
                    return Number(cur.soldTickets) + prev;
                  }, 0);
                }
                item.removeIconShow = 2;
                item.soldTicketsSum = soldTicketsSum;
                currentList.push(item);
              } else {
                currentList.push({
                  schedulingTime: minTime + 86400 * i,
                  shift: [],
                  removeIconShow: 2, // 控制日期是否可被可被移除, 1-可以移除，显示，2-可以移除，不显示，其他-不可移除
                  soldTicketsSum: 0
                });
              }
            }
          } else {
            currentList = res.scheduling.map((item) => {
              let soldTicketsSum = 0;
              if (item.shift && item.shift.length > 0) {
                soldTicketsSum = item.shift.reduce(function (prev, cur) {
                  return cur.soldTickets + prev;
                }, 0);
              }
              item.removeIconShow = 2;
              item.soldTicketsSum = soldTicketsSum;
              return item;
            });
          }


          let times1 = res.lineVehicleList ? res.lineVehicleList.map((item) => item.schedulingTime) : [];
          let times2 = currentList ? currentList.map((item) => item.schedulingTime) : [];
          let times = Array.from(new Set([...times1, ...times2]));
          currentList.forEach((item) => {
            let target = times.find((time) => time == item.schedulingTime);
            // 判断是不是已有的数据
            if (target) {
              // 班次信息数据初始化
              this.schedulingJson.push(item);
            }
          });
          this.form.shiftActive = currentList && currentList.length > 0 && currentList[this.dateActiveIndex].shift ? currentList[this.dateActiveIndex].shift : [];

        } else {
          // 班次为空情况下
          let tomorrow = new Date().setHours(0, 0, 0, 0) / 1000; // 当天0点

          this.schedulingJson.push({
            schedulingTime: tomorrow,
            shift: [],
          });

          this.form.shiftActive = [];
        }
        this.lineInfo = res.line || {};
      }
    },

    // 跳转编辑班次页面
    editShift() {
      this.$router.push({
        path: '/schedulingTimeFormEdit',
        query: {id: this.lineId, schedulingTime: this.selectSchedulingTime}
      })
    },


    getWeek(timestamp) {
      let date = new Date(timestamp * 1000);
      var week;
      if (date.getDay() == 0) week = "周日";
      if (date.getDay() == 1) week = "周一";
      if (date.getDay() == 2) week = "周二";
      if (date.getDay() == 3) week = "周三";
      if (date.getDay() == 4) week = "周四";
      if (date.getDay() == 5) week = "周五";
      if (date.getDay() == 6) week = "周六";
      return week;
    },

    //删除班次
    removeFn(row) {
      this.$confirm(`确定删除班次吗？`, "提示").then(async () => {
        let url = "/api/v1/manage/line/scheduling/" + row.id;
        let data = await this.$axios.delete(url);
        if (data && data.code == 1) {
          this.$message.success('班次已删除');
          this.getInfo();
        }
      })
    },

    /* 点击日期按钮 */
    async dateClick(item, i) {
      this.dateActiveIndex = i;
      this.form.shiftActive = item.shift || [];
    },

    /* 删除某个排班日期 */
    async removeSchedulingTime(scheduling, i) {
      let date = this.$utils.timeFn(this.schedulingJson[i].schedulingTime, "MM-DD");
      if (scheduling.soldTicketsSum > 0) {
        this.$alert(`该日期(${date})下已有乘客购票，无法被删除！`, "提示");
        return;
      }
      this.$confirm(`确认删除该日期(${date})下全部班次吗？`, "删除提示").then(async () => {
        let url = "/api/v1/manage/line/scheduling/batch/" + this.lineId;
        let data = await this.$axios.delete(url, {schedulingTime: scheduling.schedulingTime});
        if (data && data.code == 1) {
          this.$message.success("已删除");
          if (i == this.dateActiveIndex) {
            this.dateActiveIndex = 0;
          }
          this.getInfo()
        }
      });
    },

    /* 前往班线调度 */
    dispatchLineClick() {
      if (this.menuPreFn(51)) {
        this.$router.push({path: '/dispatchLine', query: {schedulingTime: this.selectSchedulingTime}})
      } else {
        this.$message.warning('当前机构或账号无权限，请联系管理员');
      }

    }
  },
};
</script>

<style lang="less" scoped>
#schedulingTimeForm {
  .schedulingTimeForm-head {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: #333333;

      .icon-line {
        width: 20px;
        margin-right: 8px;
        height: auto;
      }

      .icon-type {
        font-size: 16px;
        margin-left: 22px;
        font-weight: 500;
        line-height: 30px;
        border-radius: 4px;
        color: #409efc;
        padding: 2px 8px;
        background: rgba(64, 158, 252, 0.1);
      }

      .line-money {
        display: flex;
        align-items: center;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        height: 36px;
        padding: 0 12px;
        margin-left: 22px;

        img {
          width: 20px;
          height: auto;
          margin-right: 4px;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
      }
    }
  }

  .schedulingTimeForm-body {
    display: flex;
    flex-flow: column;

    .el-input {
      min-width: 100px;
      width: 100%;
    }

    .ticket-num {
      width: 110px;

      /deep/ input {
        padding: 0 10px;
        text-align: center;
      }
    }
  }

  .scheduling-form-date {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 12px 0;

    .left {
      width: 100%;
    }
  }

  .scheduling-form-table {
    margin-top: 12px;
    /*height: 100%;*/
    /*overflow: auto;*/
    width: 100%;

    .el-input__inner {
      width: 100%;
    }

    .el-radio-group {
      display: flex;
      align-items: center;

      .el-input-group__append {
        padding: 0 6px;
      }
    }

    .table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ebeef5 !important;
      outline: none;

      th,
      td {
        height: 38px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        width: 130px;
        border-color: #ebeef5 !important;
        box-sizing: border-box;
        padding: 0 12px;
      }

      th {
        background-color: #fafafa;
        text-align: left;
      }

      .gray td {
        color: #999 !important;
      }
    }

    .table_scheduling {
      .el-button {
        margin-left: 0;
        margin-right: 10px;
      }

      .th1,
      .th5,
      .th7,
      .th8 {
        width: 80px;
      }

      .th6 {
        width: 120px;
      }

      .th4 {
        width: 160px;
        padding: 12px;
        line-height: 20px;
      }
    }

    .el-form-item__error {
      z-index: 10;
      white-space: nowrap;
    }
  }

  .editShiftForm {
    .el-form-item {
      margin-bottom: 18px;
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-radio {
    position: relative;
    top: 1.5px;
  }

  .motoal {
    text-align: center;
    margin-top: 20px;
  }

  // 禁用input的number箭头
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /deep/ .el-dialog {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 20px;
    }

    .el-input-group__prepend {
      padding: 0 10px;
    }

    .el-input-group .el-input__inner {
      border-radius: 0px 4px 4px 0 !important;
      border-right: 1px solid #dcdfe6 !important;
    }
  }
}

.LookSeat {
  .seats-price {
    padding: 0 0 0 160px;
    box-sizing: border-box;
  }

  .seat-top {
    display: flex;
    justify-content: center;

    > div {
      display: flex;
      align-items: center;
    }

    .seat-top-left {
      margin-right: 40px;
    }

    .seat-top-right {
      margin-left: 20px;
    }

    .seat-top-span1 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/kexuan.png") no-repeat;
      background-size: 100% 100%;
    }

    .seat-top-span2 {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      background: url("../../../assets/img/yixuan.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .seat-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .content-center {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      position: relative;

      .seat-details {
        color: #409efc;
        position: absolute;
        top: -4px;
        left: 15px;
      }

      .seat-details1 {
        color: #fff;
        position: absolute;
        top: -4px;
        left: 15px;
      }
    }

    .driver {
      text-align: center;
      font-weight: bold;
      margin-left: 100px;
      margin-top: 10px;
    }

    .drivers {
      margin-bottom: 8px;
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: url("../../../assets/img/siji.png");
      font-weight: bold;
    }
  }

  .passe1 {
    margin-top: 10px;

    > p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 60px;
      margin-right: 60px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 50px;
    }

    &:nth-child(5) {
      margin-left: 40px;
    }
  }

  .passe2 {
    margin-top: 10px;

    > p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
      margin-right: 20px;
    }

    &:nth-child(5) {
      margin-left: 70px;
    }

    &:nth-child(6) {
      margin-left: 45px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }
  }

  .passe3 {
    margin-top: 10px;

    > p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 70px;
    }

    &:nth-child(3) {
      margin-left: 70px;
    }

    &:nth-child(4) {
      margin-left: 45px;
    }

    &:nth-child(5) {
      margin-left: 45px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 45px;
    }

    &:nth-child(8) {
      margin-left: 45px;
    }
  }

  .passe4 {
    margin-top: 10px;

    > p {
      margin-top: 8px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
    }

    &:nth-child(2) {
      margin-left: 70px;
      margin-right: 0px;
    }

    &:nth-child(3) {
      margin-left: 100px;
    }

    &:nth-child(4) {
      margin-left: 70px;
    }

    &:nth-child(5) {
      margin-left: 100px;
    }

    &:nth-child(6) {
      margin-left: 70px;
    }

    &:nth-child(7) {
      margin-left: 78px;
    }

    &:nth-child(8) {
      margin-left: 40px;
    }

    &:nth-child(9) {
      margin-left: 40px;
    }
  }
}

.updatePrice {
  margin-top: -20px;
  margin-bottom: 20px;

  .detail {
    font-size: 17px;
    font-weight: bolder;
    padding-right: 10px;
  }

  .update {
    cursor: pointer;
    color: #0288ff;
  }
}

.submit {
  margin-top: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    width: 100px;
    padding: 7px 15px;
  }
}
</style>
